import { useEffect } from 'react';
import axios from 'axios';

import useLineLiff from 'hooks/LineLiff';

const LexusLounge = () => {
  const { userInfo } = useLineLiff(process.env.REACT_APP_LIFF_ID_LEXUS_LOUNGE);

  useEffect(() => {
    if (!userInfo) return;

    const fetchUserLounge = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/lexus/lounge`,
          {
            user_id: userInfo.userId,
          }
        );
        if (!response.data.success) {
          throw new Error(response.data.message);
        }

        window.location.href = response.data.data.redirect_url;
      } catch (err) {
        console.error(err);
        alert(`error occurred while entering lounge: ${err.message}`);
      }
    };

    fetchUserLounge();
  }, [userInfo]);

  return (
    <div>
      <h1>Lexus Lounge</h1>
      <p>Entering...</p>
    </div>
  );
};

export default LexusLounge;
